import { MetadataText, formatDateFuture } from '@spotify/confidence-core-react';
import { WorkflowInstanceCheckFragment } from '@spotify/confidence-graphql';
import { checkFailed } from '@spotify/plugin-confidence-workflows-react';

type DraftReadinessTextProps = {
  checks: ReadonlyArray<Pick<WorkflowInstanceCheckFragment, 'state'>>;
  plannedStartDate?: Date | null;
};

export const DraftReadinessText = ({
  checks,
  plannedStartDate,
}: DraftReadinessTextProps) => {
  const isReady = !checks.some(c => checkFailed(c.state));
  return (
    <MetadataText
      items={[
        isReady ? 'Ready' : 'A few things left',
        isReady && plannedStartDate && formatDateFuture(plannedStartDate),
      ]}
    />
  );
};
